import React, { useEffect } from 'react'
import NodataImage from "../../Assests/nodata.gif"

export default function Compare() {

  const [compareDate,setCompareData] = React.useState([])



  const getLocalStorage = ()=>{

    var data = localStorage.getItem('compareData');
    console.log("potta",data)
    if(data){
      data = JSON.parse(data)
      if(data.length < 2){
       return setCompareData(data)
      }
     return setCompareData(data.slice(Math.max(data.length - 2, 0)))
    }
  }
  useEffect(()=>{
getLocalStorage()

  },[])
  return (


    <section
    className="services-area bg-white mt-120 pb-120 wow fadeInUp"
    style={{ display: "flex", flexDirection: "row" }}
  >
    <div className="container">
      <div className="section-title mb-45">
      <h2 className="wow fadeInUp" style={{ visibility: "visible", animationName: "fadeInUp" }}>Learn our recruitment process</h2>
                    <p className="wow fadeInUp mb-20" data-wow-delay="0.3s" style={{ visibility: "visible", animationDelay: "0.3s", animationName: "fadeInUp" }}>Recruitment is a process of finding and attracting the
                        potential resources for filling up the
                        vacant positions in an organization. It sources the candidates with the abilities and attitude,
                        which are required for achieving the objectives of an organization.</p>
        <div className="table-responsive">

          {
           ( compareDate.length < 2) ? <div>

              <img src={NodataImage} alt="No Data" id='noDataImg'/>
              </div>

              :
              
              <table className="table table-borderless mb-0">
              <thead>
                <tr  style={{ backgroundColor: "whitesmoke" }}>
                  <th className="text-center">Feature</th>
                  <th className="text-center">{compareDate[0].bankName}</th>
                  <th className="text-center">{compareDate[1].bankName}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                  <td  className="feature-item">  {"Intrest Rate".toUpperCase()}  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {compareDate[0].interestRate}  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {compareDate[1].interestRate}  </td>
                    </tr>
                    <tr>
                  <td  className="feature-item">  {'Processing Fee'.toUpperCase()}  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {compareDate[0].processingFee}  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {compareDate[1].processingFee}  </td>
                    </tr>
                    <tr>
                  <td  className="feature-item">  {'Loan Amount'.toUpperCase()}  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {compareDate[0].loanAmount}  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {compareDate[1].loanAmount}  </td>

                    </tr>
                    <tr>
                  <td  className="feature-item">  {'Tenure'.toUpperCase()}  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {compareDate[0].tenure}  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {compareDate[1].tenure}  </td>
                    </tr>
                    <tr>
                  <td  className="feature-item">  {'Eligibility'.toUpperCase()}  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {compareDate[0].eligibility}  </td>
                  <td  className="feature-item" style={{fontWeight:"normal"}}>  {compareDate[1].eligibility}  </td>
                    </tr>
             
                  </tbody>

                  </table>
          }
      
        </div>
      </div>
    </div>
  </section>
   
  )
}
